export const SET_ADDON_EMAIL = "SET_ADDON_EMAIL";

export const setAddOnEmail = (payload) => {
	return {
		type: SET_ADDON_EMAIL,
		payload,
	};
};
